import { z } from 'zod';
/* =========================================================================
 * User UI preferences cross-device sync (Feature B-03)
 *
 * Outbound commands (client → server):
 *   user:ui-prefs-get    — request current prefs (no body); server replies
 *                          via user:ui-prefs-updated to sender only.
 *   user:ui-prefs-set    — shallow-merge a patch into User.uiPreferences;
 *                          server persists и echoes user:ui-prefs-updated
 *                          to sender (carries final merged state).
 *
 * Broadcast event (server → owner devices):
 *   user:ui-prefs-updated  — authoritative current prefs after persist.
 * ========================================================================= */
export const USER_UI_PREFS_MSG = {
    // outbound (commands)
    get: 'user:ui-prefs-get',
    set: 'user:ui-prefs-set',
    // inbound (broadcast event)
    updated: 'user:ui-prefs-updated',
};
export const UserUiPrefsSetBody = z.object({
    prefs: z.record(z.string(), z.unknown()),
});
export const UserUiPrefsUpdatedBody = z.object({
    userId: z.string(),
    prefs: z.record(z.string(), z.unknown()),
});
